import { MenuItem } from "@mui/material";
import { forwardRef } from "react";
import { OperatorType } from "~/pages/space/workspaces/components/ConditionBuilder/types";
import { ConditionTageBaseOperatorDropdown } from "~/components/ConditionBuilder/ConditionTagOperatorDropdown/ConditionTageBaseOperatorDropdown";
import { useWorkspaceConditionOperatorDropdown } from "./hooks/useWorkspaceConditionOperatorDropdown";

interface WorkspaceConditionOperatorDropdownProps {
  type: OperatorType;
  defaultValue?: string | undefined;
  isReadonly: boolean;
}

export const WorkspaceConditionOperatorDropdown = forwardRef(
  (
    {
      type,
      defaultValue,
      isReadonly,
      ...rest
    }: WorkspaceConditionOperatorDropdownProps,
    _ref,
  ) => {
    const { operators, operatorsLabelMap } =
      useWorkspaceConditionOperatorDropdown({ type });

    return (
      <ConditionTageBaseOperatorDropdown
        defaultValue={defaultValue}
        isReadonly={isReadonly}
        renderContent={() =>
          operators.map((operator) => (
            <MenuItem key={operator} value={operator}>
              {operatorsLabelMap[operator]}
            </MenuItem>
          ))
        }
        {...rest}
      />
    );
  },
);
